import { AxiosResponse } from 'axios';
import { NotificationParams } from '@/types/api';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

const sendNotifications = async (params: NotificationParams): Promise<AxiosResponse<void>> => {
  // No-op: notifications were sent via the old API (Slack/email).
  // Will need Supabase Edge Functions later.
  return asResponse(undefined as unknown as void);
};

export default {
  sendNotifications,
};
